export default __webpack_public_path__ + "static/12-b379f783a94cc0a3c35a3cf1370a3355.jpg";